import OnboardingChecklist from './onboarding-checklist';
import CourseProgressWidget from './widgets/course-progress';
import PortfolioWidget from './widgets/portfolio';
import PremiumWidget from './widgets/premium';
import RecentlyGradedWidget from './widgets/recently-graded';
import {Carousel, Slide} from 'vue-carousel';

export default {
  data: {
    current_progress: [],
    current_time: null,
    widgets: [],
    my_courses: [],
    rec_courses: [],
    share_emails: null,
    share_description: '',
    show_share_modal: false,
    share_modal_params: null,
    show_cohort_locked_modal: false,
    cohort_locked_modal_params: null,
    show_locked_modal: false,
    locked_modal_params: null,
    show_unlock_modal: false,
    unlock_modal_params: null,
    show_onboarding_modal: false,
    show_onboarding_tour: false,
    onboarding_tooltip_params: {
      arrow: true, position: 'top', template: null, interactive: null, disabled: false, rerenderOnUpdate: true
    },
    carousel: {
      course: {page_count: 0, first_page: false, last_page: false},
      rec: {page_count: 0, first_page: false, last_page: false}
    }
  },
  components: {
    OnboardingChecklist,
    CourseProgressWidget,
    RecentlyGradedWidget,
    PortfolioWidget,
    PremiumWidget,
    Carousel,
    Slide
  },
  computed: {
    loadingProgress() {
      return this.current_progress.length === 0;
    },
    showOnboardingModal() {
      return !is.mobile() && this.show_onboarding_modal;
    },
    dontShowAgainModal() {
      return localStorage.getItem("dont_show_again")
    },
    relativeUnlockTime() {
      if (this.show_cohort_locked_modal) {
        let currentTime = this.current_time;
        const daysAway = moment(this.cohort_locked_modal_params.next_cohort_occurrence).diff(moment(), 'days');
        if (moment(this.current_time).isSameOrAfter(this.cohort_locked_modal_params.next_cohort_occurrence)) {
          this.show_cohort_locked_modal = false;
        }
        if (daysAway > 7) {
          return `till ${Kadenze.Util.getMomentDate(this.cohort_locked_modal_params.next_cohort_occurrence).format(Kadenze.I18n.t('date.formats.js_default_time'))} when`;
        } else {
          return `${Kadenze.Util.getMomentDate(this.cohort_locked_modal_params.next_cohort_occurrence).fromNow(true)} until`;
        }
      }
    },
  },
  methods: {
    bindData(data) {
      this.user = data.user;
      this.my_courses = data.my_courses;
      this.rec_courses = data.rec_courses;
      this.onboarding_checklist = data.onboarding_checklist;
      this.default_course = data.default_course;
      this.show_onboarding_modal = data.onboarding_checklist.show_onboarding_modal;

      if(data.student_access_on_draft_course){
        this.showNotPublishedNotice()
      }

    },
    makeRequest: _.memoize(function (url, loadingIndicator) {
      return new Kadenze.AjaxRequest({
        type: 'GET',
        url: url,
        loadingIndicator: loadingIndicator
      });
    }),
    getProgress() {
      this.makeRequest(Kadenze.Routes.current_progress_path()).done((data) => {
        this.current_progress = data;
        this.widgets = [
          {is:'CourseProgressWidget', courses: this.current_progress.courses},
          {is: 'RecentlyGradedWidget', grades: this.current_progress.grades},
          {is: 'PortfolioWidget'}
        ];
      });
    },
    triggerOnboarding() {
      this.show_onboarding_tour = true;
    },
    onboardingTooltipParams(type, order, end = false) {
      return {arrow: true, rerenderOnUpdate: true, disabled: !this.show_onboarding_tour, template: `templates/tooltips/student/home/${type}/onboarding${order}`, interactive: { scroll: true, overlay: false, context: 'UserHomeOnboarding', order: order, end: end } };
    },
    updateCarouselNav(type = 'course') {
      this.carousel[type].page_count = this.$refs[`${type}Carousel`].pageCount;
      this.carousel[type].first_page = this.$refs[`${type}Carousel`].currentPage === 0;
      this.carousel[type].last_page = this.$refs[`${type}Carousel`].currentPage === (this.$refs[`${type}Carousel`].pageCount - 1);
    },
    navCarousel(type = 'course', action = 'next') {
      if (action === 'next')
        this.$refs[`${type}Carousel`].goToPage(this.$refs[`${type}Carousel`].getPreviousPage());
      else
        this.$refs[`${type}Carousel`].goToPage(this.$refs[`${type}Carousel`].getNextPage());
      this.updateCarouselNav(type);
    },
    showShareModal(params) {
      this.share_modal_params = params;
      this.show_share_modal = true;
    },
    showCohortLockedModal(params) {
      this.cohort_locked_modal_params = params;
      this.show_cohort_locked_modal = true;
    },
    bypassCohortLock() {
      const request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.bypass_cohort_lock_course_path(this.cohort_locked_modal_params.id),
        loadingIndicator: true
      });

      request.done((data) => {
        this.show_cohort_locked_modal = false;
        if (data.redirect_path)
          window.location.pathname = data.redirect_path;
      });
    },
    showLockedModal(params) {
      this.locked_modal_params = params;
      this.show_locked_modal = true;
    },
    showUnlockModal(params) {
      this.unlock_modal_params = params;
      this.show_unlock_modal = true;
    },

    showNotPublishedNotice() {
      $('.js-course-not-published-modal--fields').modal('show');
    }
  },
  mounted() {
    if (this.user.has_enrolled)
      this.getProgress();
    if (this.my_courses.length > 0)
      this.updateCarouselNav('course');
    if (this.rec_courses.length > 0)
      this.updateCarouselNav('rec');
    this.interval = setInterval(() => this.current_time = new Date(), 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
